



































































import { mapGetters } from "vuex";
import CardDisplayImage from "@/components/CardDisplay/CardDisplayImage.vue";
import { i18n } from "@/plugins/i18n";

export default {
  name: "TheLaatstBekeken",
  components: { CardDisplayImage },
  props: {
    skipFirst: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getLaatstBekekenItems"])
  },
  methods: {
    navigateTo(item) {
      this.$store.commit("setItemIds", []);
      this.$router.push({
        name: "Details",
        params: { id: item.materieelSoort }
      });
    },
    getTranslation(item) {
      if (item.vertalingen && item.vertalingen.hasOwnProperty(i18n.locale)) {
        return item.vertalingen[i18n.locale];
      }

      return item.omschrijving;
    },
    scrollRight() {
      this.$refs.scroll.scrollLeft += 100;
    },
    scrollLeft() {
      this.$refs.scroll.scrollLeft -= 100;
    }
  }
};
